import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import { Media, Row, Col, Container } from "reactstrap";
import privacyImg from '../../../resources/custom/images/privacy-policy.jpg';
import CustomerTestimonial from '../../components/shared/CustomerTestimonial';

const PrivacyPolicy = () => {
  const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);

  return (
    <>
      <Helmet>
        <title>{siteTitle} - Privacy Policy</title>
        <meta name="description" content={siteTitle + " - Privacy Policy page"} />
        <meta name="keywords" content="Privacy Policy"></meta>
      </Helmet>

      <SiteBreadcrumb title="Privacy Policy" parent="Home" />

      <section className="privacy-policy section-big-py-space">
        <div className="custom-container">
          <Row>
            <Col lg="4">
              <div className="banner-section">
                <Media src={privacyImg} className="img-fluid w-80" alt="" />
              </div>
            </Col>
            <Col lg="8">
              <h4>Our Privacy Policy</h4>
              {/* <p className="mb-2">
                {" "}
                Welcome to <b>Parijat Handicraft -</b> Elevate Your Surroundings with Artistic Grace!
              </p> */}
              <p className="mb-2">
                {" "}
                If you share your personal information with us or our other entities, we are entitled to disclose personal information to third parties. Parijat Handicraft may disclose your personal information if required to do so by law or in the good faith belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal process. We are entitled to share some or all of your personal information with another business entity should we plan to merge with.
              </p>
              {/* <p className="mb-2">
                {" "}

                Just like the delicate Parijat flower that blooms in the moonlight, our handicrafts exude natural beauty and timeless charm. Explore a range of products that echo the rhythms of nature, bringing a touch of tranquility and sophistication to your surroundings.
              </p>
              <p>
                {" "}
                <b>Parijat Handicraft</b> seamlessly merges the age-old artistry of traditional craftsmanship with the modern touch of innovation. Our online platform offers you a user-friendly and immersive experience, ensuring that your journey through our collections is as delightful as the pieces themselves.
              </p> */}
            </Col>
          </Row>
        </div>
      </section>
      <CustomerTestimonial />
    </>
  );
};

export default PrivacyPolicy;
